import { isConfigChangeCapabilityViolationError } from './config-change-capabilities';
import { isIpsDialectCapabilityViolationError } from './ips-dialect-capabilities';
import { isNetworkProviderCapabilityViolationError } from './network-provider-capabilities';
import { isWafVendorCapabilityViolationError } from './waf-vendor-capabilities';

export const isPreventionCapabilityViolationError = (error: unknown): boolean =>
  isWafVendorCapabilityViolationError(error) ||
  isNetworkProviderCapabilityViolationError(error) ||
  isConfigChangeCapabilityViolationError(error) ||
  isIpsDialectCapabilityViolationError(error);
